package fr.frux.feature.harvests

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel
import fr.frux.core.maps.MapCameraPosition
import fr.frux.shared.domain.model.Place
import kotlinx.coroutines.flow.Flow

/**
 * Contrat de fabrique du [HarvestsViewModel], honoré par le composition root (#43). La caméra
 * de la carte vient de l'appelant (#534) : elle vit dans `App`, pas dans le graphe.
 */
fun interface HarvestsViewModelFactory {
    fun create(
        mapCamera: Flow<MapCameraPosition>,
        recenterMap: (Place) -> Unit,
    ): HarvestsViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalHarvestsViewModelFactory =
    staticCompositionLocalOf<HarvestsViewModelFactory> {
        error("HarvestsViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
    }

@Composable
fun rememberHarvestsViewModel(
    mapCamera: Flow<MapCameraPosition>,
    recenterMap: (Place) -> Unit,
): HarvestsViewModel {
    val factory = LocalHarvestsViewModelFactory.current
    return viewModel { factory.create(mapCamera, recenterMap) }
}
